// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.livestreamsourceerror{
    color: red;
}
.css-13cymwt-control {
    align-items: center;
    cursor: default;
    display: flex;
    -webkit-box-flex-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 38px;
    outline: 0!important;
    position: relative;
    transition: all 100ms;
    background-color: transparent !important;
    border-color: transparent !important;
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
}

.css-t3ipsp-control {
    align-items: center;
    cursor: default;
    display: flex;
    -webkit-box-flex-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 38px;
    outline: 0!important;
    position: relative;
    transition: all 100ms;
    background-color: transparent !important;
    border-color: transparent !important;
    /* border-radius: 4px; */
    /* border-style: solid; */
    /* border-width: 1px; */
    box-shadow: none !important;
    box-sizing: border-box;
}
.css-qbdosj-Input {
    visibility: visible;
    flex: 1 1 auto;
    display: inline-grid;
    grid-area: 1/1/2/3;
    grid-template-columns: 0 min-content;
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    outline: transparent !important;
}
.form-select {
    display: block;
    width: 100%;
    padding: .375rem 2.25rem .375rem .75rem;
    -moz-padding-start: calc(0.75rem - 3px);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: transparent !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    appearance: none;
}
.form-select:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: none !important;
}

.t-1{
    font-size: 12px;
}
textarea#description {
    height: 120px;
}

.file-draganddrop {
    height: 100px;
    align-items: center;
    justify-content: center;
    border-width: 2px;
    border-radius: 1rem;
    border-style: dashed;
    text-align: center;
    border-color: #cbd5e1;
    background-color: transparent;
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/Live Stream/Management_Live_Stream/AddNewLiveStream.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;AACA;IAII,mBAAmB;IACnB,eAAe;IAIf,aAAa;IACb,2BAA2B;IAG3B,eAAe;IAGf,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAElB,qBAAqB;IACrB,wCAAwC;IACxC,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IAII,mBAAmB;IACnB,eAAe;IAIf,aAAa;IACb,2BAA2B;IAG3B,eAAe;IAGf,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAElB,qBAAqB;IACrB,wCAAwC;IACxC,oCAAoC;IACpC,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IAGnB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,+BAA+B;AACnC;AACA;IACI,cAAc;IACd,WAAW;IACX,uCAAuC;IACvC,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,yDAAiP;IACjP,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;IAC1B,qBAAqB;IACrB,qEAAqE;IAGrE,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;EAC/B","sourcesContent":[".livestreamsourceerror{\n    color: red;\n}\n.css-13cymwt-control {\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    cursor: default;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex-wrap: wrap;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    justify-content: space-between;\n    min-height: 38px;\n    outline: 0!important;\n    position: relative;\n    -webkit-transition: all 100ms;\n    transition: all 100ms;\n    background-color: transparent !important;\n    border-color: transparent !important;\n    border-radius: 4px;\n    border-style: solid;\n    border-width: 1px;\n    box-sizing: border-box;\n}\n\n.css-t3ipsp-control {\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    cursor: default;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex-wrap: wrap;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    justify-content: space-between;\n    min-height: 38px;\n    outline: 0!important;\n    position: relative;\n    -webkit-transition: all 100ms;\n    transition: all 100ms;\n    background-color: transparent !important;\n    border-color: transparent !important;\n    /* border-radius: 4px; */\n    /* border-style: solid; */\n    /* border-width: 1px; */\n    box-shadow: none !important;\n    box-sizing: border-box;\n}\n.css-qbdosj-Input {\n    visibility: visible;\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    display: inline-grid;\n    grid-area: 1/1/2/3;\n    grid-template-columns: 0 min-content;\n    margin: 2px;\n    padding-bottom: 2px;\n    padding-top: 2px;\n    color: hsl(0, 0%, 20%);\n    box-sizing: border-box;\n    outline: transparent !important;\n}\n.form-select {\n    display: block;\n    width: 100%;\n    padding: .375rem 2.25rem .375rem .75rem;\n    -moz-padding-start: calc(0.75rem - 3px);\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: transparent !important;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right .75rem center;\n    background-size: 16px 12px;\n    border-radius: .25rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n.form-select:focus {\n    border-color: #86b7fe;\n    outline: 0;\n    box-shadow: none !important;\n}\n\n.t-1{\n    font-size: 12px;\n}\ntextarea#description {\n    height: 120px;\n}\n\n.file-draganddrop {\n    height: 100px;\n    align-items: center;\n    justify-content: center;\n    border-width: 2px;\n    border-radius: 1rem;\n    border-style: dashed;\n    text-align: center;\n    border-color: #cbd5e1;\n    background-color: transparent;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
